import './DeparturesReportUpdateFooter.scss';

import { useDeparturesReportUpdateForm } from "../../../../../hooks/useDeparturesReportUpdateForm";

import { Button } from "../../../../../common-components/Buttons/Buttons";

const DeparturesReportUpdateFooter = ({id}) => {
    const { handleSend } = useDeparturesReportUpdateForm({id});

    return (
        <div className={"departures-report-update-footer"}>
            <Button title={"Добавить"} onClick={handleSend}/>
        </div>
    )
}

export default DeparturesReportUpdateFooter;